import React, { FC } from 'react';

import { sigUsdAsset } from '../../../../../common/assets/sigUsdAsset';
import { FormTitle } from '../../../../../common/components/FormTitle/FormTitle';
import { OperationValidator } from '../../../../../common/components/OperationForm/OperationForm';
import { Currency } from '../../../../../common/models/Currency';
import {
  CommitmentForm,
  CommitmentFormModel,
} from '../../../common/CommitmentForm/CommitmentForm';

export interface PublicWhitelistFormProps {
  readonly address: string;
}

export const PublicWhitelistForm: FC<PublicWhitelistFormProps> = ({
  address,
}) => {
  const commitmentRangeValidator: OperationValidator<CommitmentFormModel> = (
    form,
  ) => {
    if (form.value.amount?.gt(new Currency(10_000_00n, sigUsdAsset))) {
      return 'Max commitment is 10k SigUSD';
    }
    return undefined;
  };

  return (
    <CommitmentForm
      roundName="spectrum-public-202301wl"
      address={address}
      title={<FormTitle>Public whitelist</FormTitle>}
      validators={[commitmentRangeValidator]}
    />
  );
};
